import type { MaybeRefOrGetter } from 'vue';
import type { SortDirection } from '#layers/base/public';
import type { GlobalPrimitiveFieldId, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { toValue } from 'vue';
import { usePermissionsStore } from '#layers/access/public';
import { SORT_DIRECTIONS } from '#layers/base/public';
import { QueryCapabilityKinds, supportedSurface, useQueryApi } from '#layers/data-model/public';

/**
 * The directions a listing may sort a field by: those the read's sort input accepts, for fields the
 * user may read. System collections sort by every direction.
 */
export function useSortGate(collection: MaybeRefOrGetter<ResolvedMonospaceCollection | undefined>) {
	const sorting = useQueryApi(collection).surface((api) => api.readMany()?.sorting());
	const permissions = usePermissionsStore();

	function directions(fieldId: GlobalPrimitiveFieldId): SortDirection[] {
		const current = toValue(collection);
		if (!current || !permissions.canReadField(current.id, fieldId)) return [];
		if (sorting.value.kind === QueryCapabilityKinds.Ungated) return [...SORT_DIRECTIONS];
		const accepted = supportedSurface(sorting.value)?.directionsById(fieldId) ?? [];
		return SORT_DIRECTIONS.filter((direction) => accepted.includes(direction));
	}

	return { directions };
}
